import { render } from "./AddMonnaieModal.vue?vue&type=template&id=00790c45&ts=true"
import script from "./AddMonnaieModal.vue?vue&type=script&lang=ts"
export * from "./AddMonnaieModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__